// extracted by mini-css-extract-plugin
export var sliderRange = "_qy-2";
export var sliderRoot = "_qy-0";
export var sliderThumb = "_qy-3";
export var sliderTrack = "_qy-1";